import React, {
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from "react"
import clsx from "clsx"

import classes from "./Dropdown.module.scss"

const Dropdown = (props) => {
  const {
    children,
    className,
    open = false,
    onOpen = () => { },
    onClose = () => { },
    dropdownButtonClassName,
    dropdownMenuClassName,
    dropdownButtonComponent
  } = props

  const [mount, setMount] = useState(false)

  const dropdownButtonRef = useRef(null)

  const dropdownMenuRef = useRef(null)

  const handleClick = () => {
    mount ? onClose() : onOpen()

    setMount(prev => !prev)
  }

  const handleClickOutside = (e) => {
    if (dropdownButtonRef.current.contains(e.target)) return

    if (dropdownMenuRef.current?.contains(e.target)) return

    setMount(false)
  }

  useLayoutEffect(() => {
    setMount(open)
  }, [open])

  useEffect(() => {
    window.addEventListener("click", handleClickOutside)

    return () => {
      window.removeEventListener("click", handleClickOutside)
    }
  }, [])

  return (
    <div className={clsx(classes["container"], className)}>
      <div
        ref={dropdownButtonRef}
        onClick={handleClick}
        className={clsx(
          classes["dropdown-button"],
          dropdownButtonClassName
        )}
      >
        {dropdownButtonComponent}
      </div>
      {mount
        ?
        <div
          ref={dropdownMenuRef}
          className={clsx(
            classes["dropdown-menu"],
            dropdownMenuClassName
          )}
        >
          {children}
        </div>
        : null
      }
    </div>
  )
}

export default Dropdown